module.exports = __webpack_public_path__ + "img/enable_bt.cdd4e6fb.svg";